var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: _vm.inputForm.mailDTO.title,
        width: "70%",
        center: "",
        "close-on-click-modal": false,
        "before-close": _vm.handleClose,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "inputForm", attrs: { size: "small", model: _vm.inputForm } },
        [
          _c(
            "div",
            [
              _c("span", [_vm._v("发件人：本人")]),
              _c("el-divider"),
              _c("span", [
                _vm._v("收件人：" + _vm._s(_vm.inputForm.receiverNames)),
              ]),
              _c("el-divider"),
              _c("span", [_vm._v("时间：" + _vm._s(_vm.inputForm.sendTime))]),
              _c("el-divider"),
              _c("el-card", { staticClass: "box-card" }, [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$utils.unescapeHTML(_vm.inputForm.mailDTO.content)
                    ),
                  },
                }),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  return _vm.handleClose()
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }